import styled from 'styled-components';


export const ContainerWrapper = styled.div`
margin-top: 8px;
`;

